import Rails from '@rails/ujs';
// Vendors
// import 'bootstrap';
import '@fortawesome/fontawesome-free/js/fontawesome'
import '@fortawesome/fontawesome-free/js/regular'
import '@fortawesome/fontawesome-free/js/solid'
import '@fortawesome/fontawesome-free/js/brands'
// Image
import '../../../../assets/images'
// Style
import '../../../../assets/stylesheets/homepage.scss'
// Custom
// import './scripts.js';
// Rails js
require("@rails/activestorage").start();
Rails.start();

console.log('Homepage')